// extracted by mini-css-extract-plugin
export default {"app":"NqOR6","scrollable":"MQKya","postPageApp":"PJALf"};